export default {
  MCHASHID: "MCHASHID",
  CITYID: "CITYID"
};



// WEBPACK FOOTER //
// ./src/config/cookieType.js